import styled from 'styled-components';

const Icon = styled('img')`
  height: 70px;
  width: auto;
  margin-bottom: 30px;
`;

export default Icon;
